module.exports = __webpack_public_path__ + "static/media/dolly.ff74611c.svg";